module.exports = __webpack_public_path__ + "img/delete_point.5676ff32.png";